/* Redux saga class
 * Create a second opinion cases the app
 * requires username and password.
 * un - username
 * pwd - password
 */
import { put, call } from 'redux-saga/effects';
import * as caseActions from '../actions/caseActions';
//import NavigationService from '../navigation/NavigationService';
//import * as Constants from '../config/constants';
import awsUserInfo from '../api/methods/awsUserInfo';
import Api from '../api/index';
//import { showMessage } from 'react-native-flash-message';

export function* getAllMyCasesSaga() {
  var status = 0;
  try {
    console.log('caseSaga:getAllMyCasesSaga - start to get all my cases');
    var token = yield call(awsUserInfo.currentJwtToken);
    var uri = encodeURI('v1/user/cases');
    console.log('call GET url: ', encodeURI(uri));
    const apiResponse = yield Api(encodeURI(uri), null, 'GET', token);
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log('caseSaga:getAllMyCasesSaga - Failed to get all my cases ', apiResponse.message);
      var errorMessage = apiResponse.message === undefined ? '' : apiResponse.message;
      yield put(caseActions.getAllMyCasesFailed(errorMessage));
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      console.log('caseSaga:getAllMyCasesSaga - Get all my cases status code:', status);

      /*console.log(
        'caseSaga:getAllMyCasesSaga - Get all my cases successfully.',
        JSON.stringify(apiResponse.result)
      );*/

      // get all provider contacts for all cases
      uri = encodeURI('v1/user/contacts');
      const apiResponse2 = yield Api(encodeURI(uri), null, 'GET', token);
      console.log('call GET url: ', encodeURI(uri));
      /* console.log(
        'caseSaga:getAllMyCasesSaga - Get all my cases contacts successfully.',
        JSON.stringify(apiResponse2.result)
      );*/

      yield put(
        caseActions.getAllMyCasesResponse(
          apiResponse.result === undefined ? [] : apiResponse.result,
          apiResponse2.result === undefined ? [] : apiResponse2.result
        )
      );
      //var msg = 'Get all my cases successfully.';
      //showMessage({message: msg, type: 'success', duration: 6000});
    } else {
      if (apiResponse.isError === true) {
        console.log(
          'caseSaga:getAllMyCasesSaga - Failed to get all my cases ',
          apiResponse.message
        );
        errorMessage = apiResponse.message === undefined ? '' : apiResponse.message;
        yield put(caseActions.getAllMyCasesFailed(errorMessage));
        //var errMessage = `Failed to create a new user. ${errorMessage}`;
        //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
      }
    }
  } catch (error) {
    if (error) {
      console.log('caseSaga:getAllMyCasesSaga - Failed to get all my cases ', error);
      yield put(caseActions.getAllMyCasesFailed(error));
      //errMessage = `Failed to get all my cases. ${error}`;
      //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
    }
  }
}

export function* createCaseSaga(action) {
  var status = 0;
  try {
    console.log('caseSaga:createCaseSaga - Start to create a new case ');
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api('v1/cases/', action.newCaseRequest, 'POST', token);
    console.log('call POST url: v1/cases/, JSON body ', action.newCaseRequest);
    console.log('apiResponse: ', apiResponse);
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log('caseSaga:createCaseSaga - Failed to create a new case', apiResponse.message);
      var response = yield put(
        caseActions.createCaseFailed(apiResponse.message === undefined ? '' : apiResponse.message)
      );
      console.log('call aseActions.createCaseFailed ', response);
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      // considering the following action will set isLogin which will
      // trigger loading of Home screen, need to do this set after case load
      console.log(
        'caseSaga:createCaseSaga - A new case is created successfully. Case id = ',
        apiResponse.result
      );

      response = yield put(caseActions.onCreateCaseResponse(apiResponse));
      /*showMessage({
        message: 'Your second opinion request is registered for you successfully.',
        type: 'success',
        duration: 6000
      });*/
      console.log('call caseActions.onCreateCaseResponse', response);
      if (apiResponse.result != 0) {
        var newCaseId = apiResponse.result;

        console.log('call caseActions.getAllMyCases');
        response = yield put(caseActions.getAllMyCases());
        console.log('caseSaga:createCaseSaga - call Finish getting all my cases.', response);
        // set cache with the created case excluding request access scenerio
        if (status !== 202) yield put(caseActions.setCaseId(newCaseId));
        //message = Constants.CREATE_CASE_SUCCESS;
        /*NavigationService.navigate('ContactYou', {
        caseId: newCaseId,
        createOrUpdate: 'create'
      });*/
      }
    } else {
      if (apiResponse.isError === true || status === 400) {
        console.log('caseSaga:createCaseSaga - Failed to create a new case', apiResponse.result);
        yield put(
          caseActions.createCaseFailed(apiResponse.message === undefined ? '' : apiResponse.message)
        );
        //message = ' If you have any further questions feel free to contact us.';
        //NavigationService.navigate('InfoMessage', {
        //  msg: apiResponse.result + message,
        //  toScreen: 'Home'
        //});
      }
    }
  } catch (error) {
    if (error) {
      console.log('caseSaga:createCaseSaga - Failed to create a new case', error);
      yield put(caseActions.createCaseFailed(error));
    }
  }
}

export function* updateCaseBasicInfoSaga(action) {
  // get the caseID
  var caseId = action.updateCaseBasicInfoRequest.caseId;
  var status = 0;
  try {
    console.log('caseSaga:updateCaseBasicInfoSaga - Start to update case basic info ');
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api(
      'v1/cases/' + caseId + '/basic',
      action.updateCaseBasicInfoRequest,
      'PUT',
      token
    );
    var consoleMsg =
      'call PUT: v1/cases/' +
      caseId +
      '/basic, body: ' +
      `${JSON.stringify(action.updateCaseBasicInfoRequest)}`;
    console.log(consoleMsg);
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log(
        'caseSaga:updateCaseBasicInfoSaga - Failed to update case. Case id = ' + caseId,
        apiResponse.message
      );
      yield put(
        caseActions.updateCaseBasicInfoFailed(
          apiResponse.message === undefined ? '' : apiResponse.message
        )
      );
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(caseActions.onUpdateCaseBasicInfoResponse(apiResponse));
      console.log(
        'caseSaga:updateCaseBasicInfoSaga - Case is updated successfully. Case id = ',
        caseId
      );
      var response = yield put(caseActions.getAllMyCases());
      console.log('caseSaga:updateCaseBasicInfoSaga - call Finish getting all my cases.', response);
    } else {
      if (apiResponse.isError === true) {
        console.log(
          'caseSaga:updateCaseBasicInfoSaga - Failed to update case. Case id = ' + caseId,
          apiResponse.message
        );
        yield put(
          caseActions.updateCaseBasicInfoFailed(
            apiResponse.message === undefined ? '' : apiResponse.message
          )
        );
      }
    }
  } catch (error) {
    if (error) {
      console.log(
        'caseSaga:updateCaseBasicInfoSaga - Failed to update case. Case id = ' + caseId,
        error
      );
      yield put(caseActions.updateCaseBasicInfoFailed(error));
    }
  }
}

export function* updateCaseContactInfoSaga(action) {
  // get the caseID
  var caseId = action.updateCaseContactInfoRequest.caseId;
  var status = 0;
  try {
    console.log('caseSaga:updateCaseContactInfoSaga - Start to update case basic info ');
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api(
      'v1/cases/' + caseId + '/contact',
      action.updateCaseContactInfoRequest,
      'PUT',
      token
    );
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log(
        'caseSaga:updateCaseContactInfoSaga - Failed to update case. Case id = ' + caseId,
        apiResponse.message
      );
      yield put(
        caseActions.updateCaseContactInfoFailed(
          apiResponse.message === undefined ? '' : apiResponse.message
        )
      );
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(caseActions.onUpdateCaseContactInfoResponse(apiResponse));
      console.log(
        'caseSaga:updateCaseContactInfoSaga - Case is updated successfully. Case id = ',
        caseId
      );
      yield put(caseActions.getAllMyCases());
    } else {
      if (apiResponse.isError === true) {
        console.log(
          'caseSaga:updateCaseContactInfoSaga - Failed to update case. Case id = ' + caseId,
          apiResponse.message
        );
        yield put(
          caseActions.updateCaseContactInfoFailed(
            apiResponse.message === undefined ? '' : apiResponse.message
          )
        );
      }
    }
  } catch (error) {
    if (error) {
      console.log(
        'caseSaga:updateCaseContactInfoSaga - Failed to update case. Case id = ' + caseId,
        error
      );
      yield put(caseActions.updateCaseContactInfoFailed(error));
    }
  }
}

export function* updateCaseMDInfoSaga(action) {
  // get the caseID
  var caseId = action.updateCaseMDInfoRequest.caseId;
  var status = 0;
  try {
    console.log('caseSaga:updateCaseMDInfoSaga - Start to update case basic info ');
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api(
      'v1/cases/' + caseId + '/mdinfo',
      action.updateCaseMDInfoRequest,
      'PUT',
      token
    );
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log(
        'caseSaga:updateCaseMDInfoSaga - Failed to update case. Case id = ' + caseId,
        apiResponse.message
      );
      yield put(
        caseActions.updateCaseMDInfoFailed(
          apiResponse.message === undefined ? '' : apiResponse.message
        )
      );
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(caseActions.onUpdateCaseMDInfoResponse(apiResponse));
      console.log(
        'caseSaga:updateCaseMDInfoSaga - Case is updated successfully. Case id = ',
        caseId
      );
      yield put(caseActions.getAllMyCases());
    } else {
      if (apiResponse.isError === true) {
        console.log(
          'caseSaga:updateCaseMDInfoSaga - Failed to update case. Case id = ' + caseId,
          apiResponse.message
        );
        yield put(
          caseActions.updateCaseMDInfoFailed(
            apiResponse.message === undefined ? '' : apiResponse.message
          )
        );
      }
    }
  } catch (error) {
    if (error) {
      console.log(
        'caseSaga:updateCaseMDInfoSaga - Failed to update case. Case id = ' + caseId,
        error
      );
      yield put(caseActions.updateCaseMDInfoFailed(error));
    }
  }
}

export function* updateCaseBCHInfoSaga(action) {
  // get the caseID
  var caseId = action.updateCaseBCHInfoRequest.caseId;
  var status = 0;
  try {
    console.log('caseSaga:updateCaseBCHInfoSaga - Start to update case basic info ');
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api(
      'v1/cases/' + caseId + '/bchinfo',
      action.updateCaseBCHInfoRequest,
      'PUT',
      token
    );
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log(
        'caseSaga:updateCaseBCHInfoSaga - Failed to update case. Case id = ' + caseId,
        apiResponse.message
      );
      yield put(
        caseActions.updateCaseBCHInfoFailed(
          apiResponse.message === undefined ? '' : apiResponse.message
        )
      );
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(caseActions.onUpdateCaseBCHInfoResponse(apiResponse));
      console.log(
        'caseSaga:updateCaseBCHInfoSaga - Case is updated successfully. Case id = ',
        caseId
      );
      yield put(caseActions.getAllMyCases());
    } else {
      if (apiResponse.isError === true) {
        console.log(
          'caseSaga:updateCaseBCHInfoSaga - Failed to update case. Case id = ' + caseId,
          apiResponse.message
        );
        yield put(
          caseActions.updateCaseBCHInfoFailed(
            apiResponse.message === undefined ? '' : apiResponse.message
          )
        );
      }
    }
  } catch (error) {
    if (error) {
      console.log(
        'caseSaga:updateCaseBCHInfoSaga - Failed to update case. Case id = ' + caseId,
        error
      );
      yield put(caseActions.updateCaseBCHInfoFailed(error));
    }
  }
}

export function* clearCaseSaga() {
  // persist
  yield put(caseActions.clearCase());
  /*NavigationService.navigate(action.toScreen, {
    alert: false
  });*/
}

export function* AccessCaseSaga(action) {
  var status = 0;
  try {
    console.log('caseSaga:accessCaseSaga - Start to submit request to access case ');
    var token = yield call(awsUserInfo.currentJwtToken);
    const apiResponse = yield Api('v1/cases/access', action.accessRequest, 'POST', token);
    console.log('call POST url: v1/cases/access, JSON body ', action.accessRequest);
    console.log('apiResponse: ', apiResponse);
    status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log('caseSaga:accessCaseSaga - Failed to submit access request', apiResponse.message);
      var response = yield put(
        caseActions.accessCaseFailed(apiResponse.message === undefined ? '' : apiResponse.message)
      );
      console.log('call aseActions.accessCaseFailed ', response);
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      var newCaseId = apiResponse.result;
      response = yield put(caseActions.onAccessCaseResponse(apiResponse));
      if (status !== 202) yield put(caseActions.setCaseId(newCaseId));
    } else {
      if (status === 400) {
        yield put(
          caseActions.accessCaseFailed(apiResponse.result === undefined ? '' : apiResponse.result)
        );
      }
    }
  } catch (error) {
    if (error) {
      console.log('caseSaga:createCaseSaga - Failed to create a new case', error);
      yield put(caseActions.accessCaseFailed(error));
    }
  }
}
